import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight, CheckCircle2 } from "lucide-react";

type FromPortal = "partner" | "client";

type ThanksSearch = {
  confirmation?: 0 | 1;
  deduped?: 0 | 1;
  from?: FromPortal;
};

export const Route = createFileRoute("/$tenantSlug/forms/$formSlug/thanks")({
  component: ThanksPage,
  validateSearch: (search): ThanksSearch => ({
    confirmation: search.confirmation === 1 ? 1 : 0,
    deduped: search.deduped === 1 ? 1 : 0,
    from:
      search.from === "partner" || search.from === "client"
        ? (search.from as FromPortal)
        : undefined,
  }),
});

function ThanksPage() {
  const { tenantSlug, formSlug } = Route.useParams();
  const { confirmation, deduped, from } = Route.useSearch();

  const portalHref = from ? `/${encodeURIComponent(tenantSlug)}/${from}` : null;
  const portalLabel = from === "partner" ? "Back to partner portal" : "Back to client portal";

  return (
    <div className="flex-1 flex items-center justify-center p-4 sm:p-8 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-md w-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-8 text-center space-y-4 shadow-sm">
        <CheckCircle2 className="size-12 mx-auto text-emerald-500" />
        <div className="space-y-1">
          <h1 className="text-lg font-medium">
            {deduped ? "Already received" : "Thanks — we've got it"}
          </h1>
          <p className="text-sm text-slate-500">
            {deduped
              ? "We've already logged this submission."
              : confirmation
                ? "A confirmation email is on its way."
                : "Your submission is being processed."}
          </p>
        </div>
        <div className="flex flex-col items-center gap-2">
          {portalHref ? (
            <Link
              to={portalHref}
              className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-md bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 font-medium"
            >
              {portalLabel} <ArrowRight className="size-3.5" />
            </Link>
          ) : null}
          <Link
            to="/$tenantSlug/forms/$formSlug"
            params={{ tenantSlug, formSlug }}
            search={from ? { from } : undefined}
            className="text-sm text-slate-600 dark:text-slate-300 hover:underline"
          >
            Submit another
          </Link>
        </div>
        <p className="text-xs text-slate-400 pt-3 border-t border-slate-100 dark:border-slate-800">
          Powered by ActionaryCRM
        </p>
      </div>
    </div>
  );
}
